import React, { useState } from 'react';
import { Globe, ChevronDown, Check } from 'lucide-react';
import { Language, useLanguage } from '../context/LanguageContext';

const LanguageSelector: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const languages: { code: Language; name: string; flag: string }[] = [
    { code: 'tr', name: t('language.tr'), flag: '🇹🇷' },
    { code: 'en', name: t('language.en'), flag: '🇬🇧' },
    { code: 'de', name: t('language.de'), flag: '🇩🇪' },
    { code: 'ru', name: t('language.ru'), flag: '🇷🇺' },
    { code: 'ar', name: t('language.ar'), flag: '🇸🇦' },
  ];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = (newLanguage: Language) => {
    setLanguage(newLanguage);
    setIsOpen(false);
  };

  const currentLanguage = languages.find(lang => lang.code === language);

  return (
    <div className="relative z-150">
      <button
        onClick={toggleDropdown}
        className="flex items-center space-x-1 bg-white rounded-md px-3 py-2 text-sm border border-gray-300 hover:bg-gray-50 transition-colors"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <Globe className="h-4 w-4 text-gray-500 mr-1" />
        <span>{currentLanguage?.flag}</span>
        <span className="hidden md:inline">{currentLanguage?.name}</span>
        <ChevronDown className="h-4 w-4 ml-1" />
      </button>

      {isOpen && (
        <div 
          className="absolute bottom-10 left-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 py-1"
          onBlur={() => setIsOpen(false)}
        >
          <div className="px-4 py-2 text-xs text-gray-500 border-b border-gray-100">
            {t('language')}
          </div>
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className="flex items-center w-full px-4 py-2 text-sm text-left hover:bg-gray-100 transition-colors"
            >
              <span className="mr-2">{lang.flag}</span>
              <span>{lang.name}</span>
              {language === lang.code && (
                <Check className="h-4 w-4 ml-auto text-blue-500" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;